import { StreamToggles } from '@features/video/types';

// Сохраненные кнопки камеры из хранилища: битые или чужого формата — как не сохраняли
export function parseToggles(value: unknown): StreamToggles | null {
  if (typeof value !== 'object' || value === null) return null;
  if (!('micOn' in value) || !('camOn' in value) || !('speakerOn' in value)) return null;
  const { micOn, camOn, speakerOn } = value;
  if (typeof micOn !== 'boolean' || typeof camOn !== 'boolean' || typeof speakerOn !== 'boolean') {
    return null;
  }
  return { micOn, camOn, speakerOn };
}
